import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { defineMessages, useIntl } from 'react-intl';
import { useState, useEffect } from 'react';
import api from '@/shared/api';
import config from '@/config';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';
const messages = defineMessages({
    WithoutRelationGroup: {
        id: 'WithoutRelationGroup',
        defaultMessage: 'Without relation group',
    },
    RelationGroups: {
        id: 'RelationGroups',
        defaultMessage: 'Relation groups',
    },
});
const RelationGroupMultiSelect = ({ selection, placeholder, onChange, }) => {
    const [items, setItems] = useState([]);
    const intl = useIntl();
    useEffect(() => {
        let cancelled = false;
        api.base.get(`${config.appUrls.api}/api/RelationGroup/GetAll`).then(({ data }) => {
            setItems([
                { id: guid.empty, label: intl.formatMessage(messages.WithoutRelationGroup) },
                ...(data !== null && data !== void 0 ? data : []).map(x => ({ id: x.id, label: x.name })).sort(dynamicSort('label')),
            ]);
        });
        return () => {
            cancelled = true;
        };
    }, [intl]);
    const [selectedItems, selectableItems] = splitItems(items, selection);
    return (_jsx(MultiSelect, { selectedItem: selectedItems, onItemRemoved: item => onChange(removeItem(selection, item)), onItemSelected: item => onChange(addItem(selection, item)), items: selectableItems, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : intl.formatMessage(messages.RelationGroups) }));
};
export default RelationGroupMultiSelect;
